import { setResize } from "./set-resize";
import { updateSvgScale } from "./svg-scale";

export const resize = (): void => {
  let resizeTimeout: NodeJS.Timeout;
  const observer = new ResizeObserver(() => {
    // Keep the delayed setResize for other functionality
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      setResize();
    }, 2000);
  });

  observer.observe(document.body);
  window.addEventListener("orientationchange", () => {
    setResize();
  });
};
